import find from 'lodash/find';
import { getRoute } from 'store/router/routerSelectors';
import { pages } from './config';

export const getPageFromState = (state) => {
  const route = getRoute(state);
  const page = find(pages, ['route', route.name]);
  if (page) return { name: page.name };
};
/*
@Rob: This is not specific to this PR but this looks like it should probably be a selector in routerSelectors given that
      it's about the route and it takes state as an input. Either that or it should take the result of getRoute as an input
      so that it decouples those two things maybe.
 */
